import { toInteger } from "lodash";
import Swiper, { Scrollbar } from "swiper";
class AccountNav extends HTMLElement {
  constructor() {
    super();
    this.swiperObject = this.querySelector(".swiper-slider");
    this.mobile = window.matchMedia("(max-width: 768px)").matches;
    this.initialSlide = this.swiperObject.getAttribute("inital_slide");

    this.swiper = new Swiper(this.swiperObject, {
      modules: [Scrollbar],
      slidesPerView: "auto",
      spaceBetween: 24,
      mousewheel: {
        forceToAxis: true,
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
      },
    });
    this.swiper.slideTo(toInteger(this.initialSlide), 0);
  }
}

customElements.define("account-nav", AccountNav);
